<template>
  <div ref="optionalContainerComponentRef" class="optional-articles-component" :class="responsiveClass">
    <div class="optional-articles-wrapper">
      <div class="optional-articles-container">
        <div class="optional-articles-set">
          <div class="optional-articles">
            <optional-article-component v-for="article in optionalArticleSet" :key="article.index"
                                        :optional-article="article" :common-travellers-set="commonTravellersSetObject"
                                        @updateOptionalArticleHeadCount="getOptionalArticleHeadCount"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OptionalArticleComponent from "./OptionalArticleComponent.vue";
import Vue                      from "vue";
import localeList               from "../translations/localeList";
import VueI18n                  from "vue-i18n";
Vue.use(VueI18n);

export default {
  name: "OptionalArticlesContainer",
  i18n: new VueI18n({
    locale: "en-US",
    fallbackLocale: "en-US",
    messages: localeList
  }),
  components: {
    OptionalArticleComponent
  },
  props: {
    optionalArticlesArrayOriginal: {
      type: [Array, Object],
      default: null
    },
    commonTravellersSetObject: {
      type: [Array, Object],
      default: null
    },
    language: {
      type: String,
      default: "en-US"
    }
  },
  emits: [
    'optionalPrices',
    'optionalMapping'],
  data() {
    return {
      selectedOption: "",
      commonTravellersSet: null,
      optionalArticlesContainerArray: null,
      optionalArticleArray: [],
      componentWidth: 0,
      responsiveClass: ""
    };
  },
  created() {
    this.commonTravellersSet = this.commonTravellersSetObject;
    this.optionalArticleSet = this.optionalArticlesArrayOriginal;

    this.optionalArticleSet.forEach(optionalArticle => {
      this.optionalArticleArray.push({
        articleCode: optionalArticle.articles[0].articleCode,
        prices: optionalArticle.otherPrices,
        headCount: 0
      });
    });

    if (this.language == "auto") {
      this.widgetLanguage = navigator.language || navigator.userLanguage;
    } else {
      this.widgetLanguage = this.language;
    }



    this.$i18n.locale = this.widgetLanguage.replace("-", "");

    setTimeout(() => {
      this.onResize();
    }, 1);
  },
  unmounted() { },
  updated() {
    this.onResize();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  methods: {
    getTotalTravelCount: function (commonTravellersSet) {
      let totalCount = 0;
      commonTravellersSet.forEach(commonTraveller => {
        totalCount += parseInt(commonTraveller.value);
      });
      return totalCount;
    },
    getOptionalArticleHeadCount: function (selectionOptionArray, articleCode, slotIndex, tour) {
      this.$emit("optionalPrices", selectionOptionArray, articleCode, slotIndex, tour);
      // console.info(this.optionalArticleArray);

    },
    setOptionalArticlesDetails(element, optionalArticle) {
      /*console.log("HTMLElement : ");
      console.log(element);
      console.log("Include Article Object : ");
      console.log(JSON.stringify(optionalArticle));*/
      this.$emit("optionalMapping", [element, optionalArticle]);
    },
    onResize() {
      if (this.$refs.optionalContainerComponentRef != null && this.$refs.optionalContainerComponentRef != undefined) {
        this.componentWidth = this.$refs.optionalContainerComponentRef.clientWidth;
        if (this.componentWidth > 1200) {
          this.responsiveClass = "break-x-large";
        } else if (this.componentWidth < 1200 && this.componentWidth >= 993) {
          this.responsiveClass = "break-x-large";
        } else if (this.componentWidth < 993 && this.componentWidth >= 769) {
          this.responsiveClass = "break-large";
        } else if (this.componentWidth < 769 && this.componentWidth >= 576) {
          this.responsiveClass = "break-medium";
        } else if (this.componentWidth < 576 && this.componentWidth >= 320) {
          this.responsiveClass = "break-small";
        } else {
          this.responsiveClass = "break-x-small";
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/common.scss";

.optional-articles-component {
  width: 100%;
  height: 100%;

  height: 200px;
  overflow: auto;

  .optional-articles-wrapper {
    width: 100%;
    height: 100%;

    .component-title-header {
      margin-bottom: 12px;

      .component-title {
        font-size: 18px;
      }
    }

    .optional-articles-container {
      width: 100%;
      height: 100%;
      overflow: auto;

      .optional-articles-set {
        width: 100%;

        .optional-articles {
          width: 100%;
          margin: 0px;
          padding: 0px;
          padding: 0 6px 0 0;
          box-sizing: border-box;
        }
      }

      /* width */
      &::-webkit-scrollbar {
        width: 6px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #dddddd;
        border-radius: 10px;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #b6b6b6;
        border-radius: 10px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #b6b6b6;
      }
    }
  }

  &.break-small,
  &.break-x-small {
    height: min-content !important;
  }
}
</style>
